<template>
  <div>
    <div id="bar2" style="width: 590px; height: 380px"></div>
  </div>
</template>
  <script>
export default {
  name: "bar2",
  props: {
    barData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      timesin3: null
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    barData() {
      clearInterval(this.timesin3);
      this.init();
    }
  },
  methods: {
    init() {
      let myChart = this.$echarts.init(document.getElementById("bar2"));
      let option = {
        grid: {
          left: "5%",
          right: "5%",
          bottom: "3%",
          top: "5%",
          containLabel: true
        },
        tooltip: {
          trigger: "item"
          // formatter: function(res) {
          //   return res.name + res.value + "家";
          // }
        },
        // legend: {
        //   textStyle: {
        //     color: "#1084f3",
        //     fontSize: "16px"
        //   },
        //   // borderRadius:[20,20,20,20],
        //   icon: "rect",
        //   itemWidth: 24,
        //   itemHeight: 8,
        //   // right: "0%",
        //   // top: "5%"
        // },
        xAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          inverse: true,
          data: this.barData.dataX,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "#004ea5",
            fontSize: 16
          }
        },
        series: [
          {
            name: "孵化级",
            type: "bar",
            data: this.barData.dataY1,
            // data: [],
            barWidth: 10,
            color: "#6ad084",
            label: {
              show: this.barData.dataY.length?false:true,
              position: "right",
              formatter: "{c}",
              fontSize: 14,
              fontWeight: "bold",
              formatter: params => {
                return this.barData.dataY1[params.dataIndex];
              }
            },
            stack: "total",
            itemStyle: {
                //     color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //         offset: 0,
                //         color: 'rgba(145, 236, 169)' // 0% 处的颜色
                //     }, {
                //         offset: 1,
                //         color: 'rgba(101, 205, 128)' // 100% 处的颜色
                //     }], false),
                borderRadius: [5, 5, 5, 5]
                // shadowOffsetX: 5,
                // shadowColor: "#ff955b"
            },
            //鼠标选中的柱状图高亮效果
            emphasis: {
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#fb0" },
                  { offset: 0.6, color: "#f60" },
                  { offset: 1, color: "#f00" }
                ])
              }
            }
          },
          {
            name: "成长级",
            type: "bar",
            data: this.barData.dataY2,
            // data: [],
            barWidth: 10,
            color: "#ff955b",
            label: {
              show: this.barData.dataY.length?false:true,
              position: "right",
              formatter: "{c}",
              fontSize: 14,
              fontWeight: "bold",
              formatter: params => {
                return this.barData.dataY2[params.dataIndex];
              }
            },
            stack: "total",
            itemStyle: {
                // color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //     offset: 0,
                //     color: 'rgba(255, 184, 144)' // 0% 处的颜色
                // }, {
                //     offset: 0.33,
                //     color: 'rgba(254, 144, 82)' // 100% 处的颜色
                // }], true),
                borderRadius: [5, 5, 5, 5]
                // shadowOffsetX: 5,
                // shadowColor: "#ff955b"
            },
            //鼠标选中的柱状图高亮效果
            emphasis: {
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#fb0" },
                  { offset: 0.6, color: "#f60" },
                  { offset: 1, color: "#f00" }
                ])
              }
            }
          },
          {
            name: "样板级",
            type: "bar",
            data: this.barData.dataY3,
            // data: [],
            barWidth: 10,
            color: "#869cff",
            label: {
              show: true,
              position: "right",
              color: "#59a0f7",
              fontSize: 14,
              fontWeight: "bold",
              formatter: params => {
                if (this.barData.dataY.length) {
                  return this.barData.dataY[params.dataIndex];
                } else {
                  return this.barData.dataY3[params.dataIndex];
                }
              }
            },
            stack: "total",
            itemStyle: {
                //     color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //         offset: 0,
                //         color: 'rgba(183, 197, 255)' // 0% 处的颜色
                //     }, {
                //         offset: 1,
                //         color: 'rgba(132, 156, 254)' // 100% 处的颜色
                //     }], false),
                borderRadius: [5, 5, 5, 5]
            },
            //鼠标选中的柱状图高亮效果
            emphasis: {
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#fb0" },
                  { offset: 0.6, color: "#f60" },
                  { offset: 1, color: "#f00" }
                ])
              }
            }
          }
        ]
      };
      myChart.clear();
      myChart.setOption(option);
      this.timesin3 = setInterval(function() {
        myChart.clear();
        myChart.setOption(option);
      }, 25000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timesin3);
        this.timesin3 = null;
      });
    }
  }
};
</script>